import React from 'react';
import enhanceWithClickOutside from 'react-click-outside';
import HeaderUserInfo from './HeaderUserInfo';
import MyProfile from './MyProfile';
import Membership from './Membership';

class InfoUser extends React.Component {
  handleClickOutside = () => {
    const { isShow, toggleShowInfoUser } = this.props;
    if (isShow) {
      toggleShowInfoUser();
    }
  };

  render() {
    return (
      <div className="wrap-popup-user-info">
        <HeaderUserInfo handleClickOutside={this.handleClickOutside} />
        <MyProfile />
        <Membership />
      </div>
    );
  }
}

export default enhanceWithClickOutside(InfoUser);
